import { AnalyticsService } from '@moment/analytics/AnalyticsService';

const VISIBILITY_FLASH_THRESHOLD_MS = 900;

const CONTENT_DISMISSED_SENT_KEY = 'contentDismissalSent';
export type DismissalReason = 'unmount' | 'background' | 'external_navigation';

export class ContentDismissalService {
  private analyticsService: AnalyticsService;
  private viewStartTime: number | null = null;
  private partner: string = '';
  private searchParams: URLSearchParams = new URLSearchParams();
  private isTracking = false;

  constructor(analyticsService: AnalyticsService) {
    this.analyticsService = analyticsService;
  }

  public startTracking(partner: string, searchParams: URLSearchParams) {
    if (this.isTracking) return;
    this.viewStartTime = Date.now();
    this.partner = partner;
    this.searchParams = searchParams;
    this.isTracking = true;
  }

  public stopTracking(reason: DismissalReason) {
    if (!this.isTracking || this.viewStartTime === null) {
      return;
    }

    const viewDuration = Date.now() - this.viewStartTime;

    // Check if the event has already been sent in this session (client-side only)
    if (!import.meta.env.SSR && sessionStorage.getItem(CONTENT_DISMISSED_SENT_KEY)) {
      this.reset();
      return;
    }

    if (viewDuration >= VISIBILITY_FLASH_THRESHOLD_MS) {
      this.analyticsService.emitContentDismissedEvent({
        partnerId: this.partner || 'unknown',
        searchParams: this.searchParams,
        duration: viewDuration,
        reason,
      });
      // Mark that the event has been sent for this session (client-side only)
      if (!import.meta.env.SSR) {
        sessionStorage.setItem(CONTENT_DISMISSED_SENT_KEY, 'true');
      }
    }
    this.reset();
  }

  private reset() {
    this.viewStartTime = null;
    this.partner = '';
    this.searchParams = new URLSearchParams();
    this.isTracking = false;
  }
}
